import React from 'react'
import { Link, useHistory } from 'react-router-dom'

// Shared admin secondary action bar: Go back / View / Save.
// Mirrors the product edit page's navbar so every admin edit page is consistent.
const AdminActionBar = ({
  loading,
  name,
  saveHandler,
  saveLabel = 'Save',
  viewUrl,
  backFallback = '/admin/productlist',
  dataChanged,
}) => {
  const history = useHistory()
  // dataChanged === false disables Save. Undefined keeps it always enabled,
  // so pages without dirty-state tracking behave as before.
  const saveDisabled = loading || dataChanged === false
  return (
    <nav className='navbar navbar-expand-lg bg-light sticky-top mb-4 z-3 productPage__navbar'>
      <div className='container'>
        <div>
          <Link
            to={backFallback}
            className='productPageNavbar__discardBtn'
            onClick={(e) => {
              e.preventDefault()
              if (
                dataChanged === true &&
                !window.confirm(
                  'You have unsaved changes. Leave this page and lose them?'
                )
              ) {
                return
              }
              if (window.history.length > 1) {
                history.goBack()
              } else {
                history.push(backFallback)
              }
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='1.5'
              stroke='currentColor'
              className='w-6 h-6 me-2'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3'
              />
            </svg>
            Go back
          </Link>

          {name && <a className='navbar-brand'>{name}</a>}
        </div>

        <div className='productPageNavbar__actionBtnBox'>
          {viewUrl && (
            <a
              href={viewUrl}
              target='_blank'
              rel='noreferrer'
              className='productPageNavbar__actionBtn'
            >
              View
            </a>
          )}

          <button
            onClick={(e) => saveHandler(e)}
            className={`productPageNavbar__actionBtn${saveDisabled ? ' productPageNavbar__actionBtn--disabled' : ''}`}
            type='button'
            disabled={saveDisabled}
          >
            {loading ? 'Saving...' : saveLabel}
          </button>
        </div>
      </div>
    </nav>
  )
}

export default AdminActionBar
